import { API_CALL_ERROR } from './../../../store/action';
import { ApiService } from './../../../api/api.service';
import { AppInjector } from './../../../app-injector';
import { takeEvery, put } from 'redux-saga/effects';
import { ADD_COLLECTION_BAG_REQUESTED, SEARCH_COLLECTIONS_REQUESTED, SEARCH_COLLECTIONS_SUCCEEDED, FETCH_COLLECTIONS_REQUESTED, FETCH_COLLECTIONS_SUCCEEDED, SORT_COLLECTIONS_REQUESTED, SORT_COLLECTIONS_SUCCEEDED, FILTER_COLLECTIONS_SUCCEEDED, FILTER_COLLECTIONS_REQUESTED } from './list.actions';
import * as _ from 'lodash';
import { NotificationService } from '../../../common/services/notification/notification.service';
import {COLLECTION_COMP} from "../collection.const";
import {DELIVERY_COMP} from "../../delivery/delivery.const";
import {PRODUCT_COMP} from "../../product/product.const";

function* getCollections(action) {
  const api = AppInjector.get(ApiService);
  try {
    let results = yield api.collection.get(action.data.pagination, action.data.sort, action.data.filter).toPromise();
    let summary = yield api.collection.getSummary().toPromise();
    yield put({ type: FETCH_COLLECTIONS_SUCCEEDED, data: results.items, pagination: results.pagination, summary });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchFetchCollectionsRequest() {
  yield takeEvery(FETCH_COLLECTIONS_REQUESTED, getCollections);
}

function* sortCollections(action) {
  const api = AppInjector.get(ApiService);
  try {
    let results = yield api.collection.get(action.data.pagination, action.data.sort, action.data.filter).toPromise();
    yield put({ type: SORT_COLLECTIONS_SUCCEEDED, data: results.items, pagination: results.pagination });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchSortCollectionRequest() {
  yield takeEvery(SORT_COLLECTIONS_REQUESTED, sortCollections);
}

function* filterCollections(action) {
  const api = AppInjector.get(ApiService);
  try {
    let results = yield api.collection.get(action.data.pagination, action.data.sort, action.data.filter, action.data.search).toPromise();
    if (!_.isUndefined(action.com)) {
      switch (action.com) {
        case DELIVERY_COMP:
          yield put({ type: FILTER_COLLECTIONS_SUCCEEDED, data: results.items, pagination: results.pagination });
          break;
        case COLLECTION_COMP:
          yield put({ type: FILTER_COLLECTIONS_SUCCEEDED, data: results.items, pagination: results.pagination });
          break;
        case PRODUCT_COMP:
          yield put({ type: FILTER_COLLECTIONS_SUCCEEDED, data: results.items, pagination: results.pagination });
          break;
        default:
          break;
      }
    } else {
    }
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchFilterCollectionRequest() {
  yield takeEvery(FILTER_COLLECTIONS_REQUESTED, filterCollections);
}

function* searchCollections(action) {
  const api = AppInjector.get(ApiService);
  try {
    let results = yield api.collection.get(action.data.pagination, action.data.sort, action.data.filter, action.data.search).toPromise();
    let summary = yield api.collection.getSummary().toPromise();
    yield put({ type: SEARCH_COLLECTIONS_SUCCEEDED, data: results.items, pagination: results.pagination, summary });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchSearchCollectionRequest() {
  yield takeEvery(SEARCH_COLLECTIONS_REQUESTED, searchCollections);
}

function* addBag(action) {
  const api = AppInjector.get(ApiService);
  try {
    yield api.collection.addBag(action.bag).toPromise();
    let results = yield api.collection.get(action.data.pagination, action.data.sort, action.data.filter).toPromise();
    AppInjector.get(NotificationService).show('success', `Bags ${action.bag} added`, 1000);
    yield put({ type: FILTER_COLLECTIONS_SUCCEEDED, data: results.items, pagination: results.pagination });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchAddBagRequest() {
  yield takeEvery(ADD_COLLECTION_BAG_REQUESTED, addBag);
}

export default [
  watchFetchCollectionsRequest,
  watchSortCollectionRequest,
  watchFilterCollectionRequest,
  watchSearchCollectionRequest,
  watchAddBagRequest
];
